<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">型号：</span>
					<el-input v-model="search_model" class="b_inp" placeholder="型号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">芯片ID：</span>
					<el-input v-model="search_chipId" class="b_inp" placeholder="型号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="compareSearchDate"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="compareSearchDate"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">机构：</span>
					<el-select v-model="search_oid" class="b_inp" filterable placeholder="请选择" :clearable="true">
						<el-option
							v-for="v in allOrganization"
							:key="v.id"
							:label="v.name"
							:value="v.id">
						</el-option>
					</el-select>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="mid"
						label="机器"
					>
					</el-table-column>
					<el-table-column
						prop="createDate"
						label="生产日期"
					>
					</el-table-column>
					<el-table-column
						prop="createNumber"
						label="生产批号"
					>
					</el-table-column>
					<el-table-column
						prop="sellDate"
						label="出售日期"
					>
					</el-table-column>
					<el-table-column
						prop="addr"
						label="省市区"
					>
					</el-table-column>
					<el-table-column
						prop="uname"
						label="所属用户"
					>
					</el-table-column>
					<el-table-column
						prop="type"
						label="类型"
					>
					</el-table-column>
					<el-table-column
						prop="model"
						label="型号"
					>
					</el-table-column>
					<el-table-column
						prop="chipId"
						label="芯片ID"
					>
					</el-table-column>
					<el-table-column
						prop="version"
						label="版本"
					>
					</el-table-column>
					<el-table-column
						prop="billing"
						label="计费方式"
					>
					</el-table-column>
					<el-table-column
						prop="remain"
						label="剩余用量"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-dropdown>
								<el-button type="primary">
									基本信息<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item style="padding: 0;">
										<p style="padding: 0 15px;" @click="handleViewClick(scope.row)">查看</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0;">
										<p style="padding: 0 15px;" @click="handleUpdateClick(scope.row)">修改</p>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown>
								<el-button type="primary">
									使用记录<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item style="padding: 0;">
										<p style="padding: 0 15px;" @click="handleRechargeRecordClick(scope.row)">充值记录</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0;">
										<p style="padding: 0 15px;" @click="handleConsumeRecordClick(scope.row)">消费记录</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0;">
										<p style="padding: 0 15px;" @click="handleTreatmentRecordClick(scope.row)">治疗记录</p>
									</el-dropdown-item>
									<el-dropdown-item style="padding: 0;">
										<p style="padding: 0 15px;" @click="handleSimRecordClick(scope.row)">SIM卡记录</p>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 查看弹框 -->
		<ViewIF :id="view_id" v-model="view_display"></ViewIF>
		<!-- 查看弹框 end -->
		
		<!-- 修改弹框 -->
		<update v-model="update_display" :id="update_id" @onSuccess="getData"></update>
		<!-- 修改弹框 end -->
		
		<!-- 充值记录弹框 -->
		<recharge-record v-model="rechargeRecord_display"></recharge-record>
		<!-- 充值记录弹框 end -->
		
		<!-- 消费记录弹框 -->
		<consume-record v-model="consumeRecord_display" :id="consumeRecord_id"></consume-record>
		<!-- 消费记录弹框 end -->
		
		<!-- 治疗记录弹框 -->
		<treatment-record v-model="treatmentRecord_display" :id="treatmentRecord_id"></treatment-record>
		<!-- 治疗记录弹框 end -->
		
		<!-- SIM卡记录弹框 -->
		<sim-record v-model="simRecord_display" :id="simRecord_id"></sim-record>
		<!-- 卡记录弹框 end -->
	</div>
</template>

<script>
	import ViewIF from './components/view.vue';
	import Update from './components/update.vue';
	import RechargeRecord from '../components/recharge_record.vue';
	import ConsumeRecord from '../components/consume_record.vue';
	import TreatmentRecord from '../components/treatment_record.vue';
	import SimRecord from '../components/sim_record.vue';
	import { mapState } from 'vuex';
	import Api from '../../../../../api/index.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				
				search_model: '',
				search_chipId: '',
				search_startDate: '',
				search_endDate: '',
				search_oid: '',
				
				tableData: [],
				currentPage: 1,
				total: 0,
				
				view_display: false,
				view_id: -1,
				
				update_display: false,
				update_id: -1,
				
				rechargeRecord_display: false,
				
				consumeRecord_display: false,
				consumeRecord_id: -1,
				
				treatmentRecord_display: false,
				treatmentRecord_id: -1,
				
				simRecord_display: false,
				simRecord_id: -1
			}
		},
		computed: {
			...mapState([
				'allOrganization'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 点击页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击查看
			handleViewClick(obj) {
				this.view_id = obj.id;
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(obj) {
				this.update_id = obj.id;
				this.update_display = true;
			},
			// 点击充值记录
			handleRechargeRecordClick() {
				this.rechargeRecord_display = true;
			},
			// 点击消费记录
			handleConsumeRecordClick(obj) {
				this.consumeRecord_id = obj.id;
				this.consumeRecord_display = true;
			},
			// 点击治疗记录
			handleTreatmentRecordClick(obj) {
				this.treatmentRecord_id = obj.id;
				this.treatmentRecord_display = true;
			},
			// 点击SIM卡记录
			handleSimRecordClick(obj) {
				this.simRecord_id = obj.id;
				this.simRecord_display = true;
			},
			
			/************************ @Function *******************************/
			// 获取列表数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					modelName: that.search_model,
					chipId: that.search_chipId,
					startTime: that.search_startDate,
					endTime: that.search_endDate,
					optId: that.search_oid,
					userType: 2
				};
				Api.findIF(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								mid: v.machineId,
								createDate: v.productionDate,
								createNumber: v.productionSerial,
								sellDate: v.saleDate,
								addr: `${ v.provinceName }${ v.cityName }${ v.areaName }`,
								uname: v.userName,
								type: v.userType == 1 ? '门店' : '用户',
								model: v.modelName,
								chipId: v.chipId,
								version: v.swVersion,
								billing: that.mapBillingFlagToLabel(v.feeType),
								remain: v.remainInfo
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startDate = new Date(this.search_startDate).getTime(),
						endDate = new Date(this.search_endDate).getTime();
					if (endDate < startDate) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},
			// 把计费方式转换为文字
			mapBillingFlagToLabel(flag) {
				let result = '';
				switch(flag) {
					case 1:
						result = '无限制';
						break;
					case 2:
						result = '包月';
						break;
					case 3:
						result = '记次';
						break;
					case 4:
						result = '计时';
						break;
				}
				return result;
			}
		},
		components: {
			ViewIF,
			Update,
			RechargeRecord,
			ConsumeRecord,
			TreatmentRecord,
			SimRecord
		}
	}
</script>

<style>
</style>
